export default function getClonedObject(obj) {
	/* eslint-disable-next-line */
	return structuredClone(obj);
}
